export const apiConstants = {
  url: "/api/statistic"
};
